
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { QRCodeSVG } from "qrcode.react";
import ReactDOMServer from "react-dom/server";

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;
/** REINDERIZAÇÃO DE IMAGEM, PARA CONVERÇÃO **/
function getBase64Image(img) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}
/** ESTABELECIMENTOS LICENCIADOS **/
const EstabelecimentosLicenciadospdf = async (dados) => {
    const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) => res.blob());
    const imageBase64 = (await getBase64Image(imageBlob));
    const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCodeSVG
            value={`https://armed.gov.ao/verifica-documento/Reprovado`}
            type="svg"
        />
    );

    const gerarTabela = () => {
        return {
            headerRows: 1,
            widths: ['auto', 'auto', '*', '*', '*', '*', '*'],
            body: [
                [
                    { text: '#', style: 'tableHeader' },
                    { text: 'Nome', style: 'tableHeader' },
                    { text: 'Tipo', style: 'tableHeader' },
                    { text: 'Nº De Processo', style: 'tableHeader' },
                    { text: 'Director Tecnico', style: 'tableHeader' },
                    { text: 'Provincia', style: 'tableHeader' },
                    { text: 'Estado', style: 'tableHeader' },
                ],
                ...dados.map((estabelecimento, index) => [
                    { text: `${index + 1}`, style: 'tableCell' },
                    { text: estabelecimento?.nome, style: 'tableCell' },
                    { text: estabelecimento?.tipo?.actividade, style: 'tableCell' },
                    { text: estabelecimento?.numeroProcesso, style: 'tableCell' },
                    { text: estabelecimento?.directorTecnico?.dadosPessoais?.nome, style: 'tableCell' },
                    { text: estabelecimento?.provincia, style: 'tableCell' },
                    { text: estabelecimento?.status, style: 'tableCell' },
                ]),
            ],
        };
    };

    const docDef = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 60, 40, 40],

        header: {
            columns: [
                { text: new Date().toLocaleDateString('pt-PT'), alignment: 'right', fontSize: 10, margin: [0, 10, 40, 0], color: '#555' },
            ],
        },

        footer: (currentPage, pageCount) => {
            return {
                columns: [
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'left', margin: [40, 0, 0, 0], fontSize: 8, color: '#666' },
                    { text: 'Gerado automaticamente pelo Gestor ARMED', alignment: 'right', margin: [0, 0, 40, 0], fontSize: 8, color: '#666' },
                ],
            };
        },

        content: [
            {
                columns: [
                    {
                        stack: [
                            {
                                svg: qrCodeSVG,
                                width: 55,
                                height: 55,
                                margin: [0, 0, 0, 0],
                            },
                            { text: 'ARMED', alignment: 'left', fontSize: 10, margin: [-4, 10, 0, 0], color: '#555' },
                        ],
                        margin: [10, -20, 0, 0]
                    },
                    {
                        stack: [
                            {
                                image: imageBase64,
                                width: 50,
                                height: 50,
                                alignment: "center",
                            },
                            {
                                text: "REPÚBLICA DE ANGOLA",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "MINISTÉRIO DA SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: 'Lista de Estabelecimentos Licenciados',
                                fontSize: 11,
                                style: 'titulo',
                                alignment: 'center',
                                margin: [0, 9, 0, 0]
                            },
                        ],
                        margin: [0, -20, 0, 0]
                    },
                    {
                        text: '',
                        style: '',
                        alignment: 'center',
                    },
                ],
            },
            { text: '\n' },
            {
                table: gerarTabela(),
                layout: {
                    fillColor: function (rowIndex) {
                        return rowIndex === 0 ? '#E0E0E0' : rowIndex % 2 === 0 ? '#F9F9F9' : null;
                    },
                    hLineWidth: function () { return 0.5; },
                    vLineWidth: function () { return 0.5; },
                    hLineColor: function () { return '#aaa'; },
                    vLineColor: function () { return '#aaa'; },
                },
            },
        ],

        styles: {
            titulo: {
                fontSize: 10,
                bold: true,
                color: '#333',
                margin: [0, 0, 0, 0],
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: '#fff',
                fillColor: '#713073',
                alignment: 'center',
                margin: [0, 4, 0, 4],
            },
            tableCell: {
                fontSize: 10,
                color: '#111',
                margin: [0, 3, 0, 3],
            },
        },
    };

    const pdfDoc = pdfMake.createPdf(docDef);
    pdfDoc.open();
};


/** SOLICIÇAO DE LICENCIAMENTO **/
const SolicitacaoLicenciamentoPdf = async (dados) => {
    const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) => res.blob());
    const imageBase64 = (await getBase64Image(imageBlob));
    const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCodeSVG
            value={`https://armed.gov.ao/verifica-documento/Reprovado`}
            type="svg"
        />
    );

    const formatarData = (data) => {
        if (!data) return '-';
        const d = new Date(data);
        return d.toLocaleString('pt-PT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    const gerarTabela = () => {
        return {
            headerRows: 1,
            widths: ['auto', '*', '*', '*', '*', '*', '*', '*', '*'],
            body: [
                [
                    { text: '#', style: 'tableHeader' },
                    { text: 'Nome', style: 'tableHeader' },
                    { text: 'Tipo', style: 'tableHeader' },
                    { text: 'Nº De Entrada', style: 'tableHeader' },
                    { text: 'Director Tecnico', style: 'tableHeader' },
                    { text: 'Solicitação', style: 'tableHeader' },
                    { text: 'Estado', style: 'tableHeader' },
                    { text: 'Data De Entrada', style: 'tableHeader' },
                    { text: 'Ultima intervenção', style: 'tableHeader' },
                ],
                ...dados.map((estabelecimento, index) => [
                    { text: `${index + 1}`, style: 'tableCell' },
                    { text: estabelecimento?.nome, style: 'tableCell' },
                    { text: estabelecimento?.tipo?.designacao, style: 'tableCell' },
                    { text: estabelecimento?.numeroEntrada, style: 'tableCell' },
                    { text: estabelecimento?.directorTecnico?.dadosPessoais?.nome, style: 'tableCell' },
                    { text: estabelecimento?.tipoEntrada, style: 'tableCell' },
                    { text: estabelecimento?.status, style: 'tableCell' },
                    { text: formatarData(estabelecimento?.createdAt), style: 'tableCell' },
                    { text: formatarData(estabelecimento?.updatedAt), style: 'tableCell' },
                ]),
            ],
        };
    };

    const docDef = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 60, 40, 40],

        header: {
            columns: [
                { text: new Date().toLocaleDateString('pt-PT'), alignment: 'right', fontSize: 10, margin: [0, 10, 40, 0], color: '#555' },
            ],
        },

        footer: (currentPage, pageCount) => {
            return {
                columns: [
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'left', margin: [40, 0, 0, 0], fontSize: 8, color: '#666' },
                    { text: 'Gerado automaticamente pelo Gestor ARMED', alignment: 'right', margin: [0, 0, 40, 0], fontSize: 8, color: '#666' },
                ],
            };
        },

        content: [
            {
                columns: [
                    {
                        stack: [
                            {
                                svg: qrCodeSVG,
                                width: 55,
                                height: 55,
                                margin: [0, 0, 0, 0],
                            },
                            { text: 'ARMED', alignment: 'left', fontSize: 10, margin: [-4, 10, 0, 0], color: '#555' },
                        ],
                        margin: [10, -20, 0, 0]
                    },
                    {
                        stack: [
                            {
                                image: imageBase64,
                                width: 50,
                                height: 50,
                                alignment: "center",
                            },
                            {
                                text: "REPÚBLICA DE ANGOLA",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "MINISTÉRIO DA SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: 'Lista de Solicitações de Licenciamento',
                                fontSize: 11,
                                style: 'titulo',
                                alignment: 'center',
                                margin: [0, 9, 0, 0]
                            },
                        ],
                        margin: [0, -20, 0, 0]
                    },
                    {
                        text: '',
                        style: '',
                        alignment: 'center',
                    },
                ],
            },
            { text: '\n' },
            {
                table: gerarTabela(),
                layout: {
                    fillColor: function (rowIndex) {
                        return rowIndex === 0 ? '#E0E0E0' : rowIndex % 2 === 0 ? '#F9F9F9' : null;
                    },
                    hLineWidth: function () { return 0.5; },
                    vLineWidth: function () { return 0.5; },
                    hLineColor: function () { return '#aaa'; },
                    vLineColor: function () { return '#aaa'; },
                },
            },
        ],

        styles: {
            titulo: {
                fontSize: 10,
                bold: true,
                color: '#333',
                margin: [0, 0, 0, 0],
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: '#fff',
                fillColor: '#713073',
                alignment: 'center',
                margin: [0, 4, 0, 4],
            },
            tableCell: {
                fontSize: 10,
                color: '#111',
                margin: [0, 3, 0, 3],
            },
        },
    };

    const pdfDoc = pdfMake.createPdf(docDef);
    pdfDoc.open();
};

const SolicitacaoLicenciamentoReprovadosPdf = async (dados) => {
    const formatarData = (data) => {
        if (!data) return '-';
        const d = new Date(data);
        return d.toLocaleString('pt-PT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) => res.blob());
    const imageBase64 = (await getBase64Image(imageBlob));
    const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCodeSVG
            value={`https://armed.gov.ao/verifica-documento/Reprovado`}
            type="svg"
        />
    );

    const gerarTabela = () => {
        return {
            headerRows: 1,
            widths: [30, '*', '*', '*', '*', '*', '*', 90],
            body: [
                [
                    { text: '#', style: 'tableHeader' },
                    { text: 'Nome', style: 'tableHeader' },
                    { text: 'Tipo', style: 'tableHeader' },
                    { text: 'Nº de Entrada', style: 'tableHeader' },
                    { text: 'Director Técnico', style: 'tableHeader' },
                    { text: 'Solicitação', style: 'tableHeader' },
                    { text: 'Estado', style: 'tableHeader' },
                    { text: 'Data de Reprovação', style: 'tableHeader' },
                ],
                ...dados.map((estabelecimento, index) => [
                    { text: `${index + 1}`, style: 'tableCell' },
                    { text: estabelecimento?.nome || '-', style: 'tableCell' },
                    { text: estabelecimento?.tipo?.designacao || '-', style: 'tableCell' },
                    { text: estabelecimento?.numeroEntrada || '-', style: 'tableCell' },
                    { text: estabelecimento?.directorTecnico?.dadosPessoais?.nome || '-', style: 'tableCell' },
                    { text: estabelecimento?.tipoEntrada || '-', style: 'tableCell' },
                    { text: estabelecimento?.status || '-', style: 'tableCell' },
                    { text: formatarData(estabelecimento?.dataDespacho), style: 'tableCell' },
                ]),
            ],
        };
    };

    const docDef = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 60, 40, 40],

        header: {
            columns: [
                { text: new Date().toLocaleDateString('pt-PT'), alignment: 'right', fontSize: 10, margin: [0, 10, 40, 0], color: '#555' },
            ],
        },

        footer: (currentPage, pageCount) => {
            return {
                columns: [
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'left', margin: [40, 0, 0, 0], fontSize: 8, color: '#666' },
                    { text: 'Gerado automaticamente pelo Gestor ARMED', alignment: 'right', margin: [0, 0, 40, 0], fontSize: 8, color: '#666' },
                ],
            };
        },

        content: [
            {
                columns: [
                    {
                        stack: [
                            {
                                svg: qrCodeSVG,
                                width: 55,
                                height: 55,
                                margin: [0, 0, 0, 0],
                            },
                            { text: 'ARMED - DLIF', alignment: 'left', fontSize: 10, margin: [-4, 10, 0, 0], color: '#555' },
                        ],
                        margin: [10, -20, 0, 0]
                    },
                    {
                        stack: [
                            {
                                image: imageBase64,
                                width: 50,
                                height: 50,
                                alignment: "center",
                            },
                            {
                                text: "REPÚBLICA DE ANGOLA",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "MINISTÉRIO DA SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: 'Lista de Solicitações de Licenciamento Reprovadas',
                                fontSize: 11,
                                style: 'titulo',
                                alignment: 'center',
                                margin: [0, 9, 0, 0]
                            },
                        ],
                        margin: [0, -20, 0, 0]
                    },
                    {
                        text: '',
                        style: '',
                        alignment: 'center',
                    },
                ],
            },
            { text: '\n' },
            {
                table: gerarTabela(),
                layout: {
                    fillColor: function (rowIndex) {
                        return rowIndex === 0 ? '#E0E0E0' : rowIndex % 2 === 0 ? '#F9F9F9' : null;
                    },
                    hLineWidth: function () { return 0.5; },
                    vLineWidth: function () { return 0.5; },
                    hLineColor: function () { return '#aaa'; },
                    vLineColor: function () { return '#aaa'; },
                },
            },
        ],

        styles: {
            titulo: {
                fontSize: 10,
                bold: true,
                color: '#333',
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: '#fff',
                fillColor: '#713073',
                alignment: 'center',
                margin: [0, 4, 0, 4],
            },
            tableCell: {
                fontSize: 10,
                color: '#111',
                margin: [0, 3, 0, 3],
            },
        },
    };

    const pdfDoc = pdfMake.createPdf(docDef);
    pdfDoc.open();
};

/** RELATORIO EMPRESAS **/
const RelatorioEmpresasPdf = async (dados) => {
    const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) => res.blob());
    const imageBase64 = (await getBase64Image(imageBlob));
    const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCodeSVG
            value={`https://armed.gov.ao/verifica-documento/Reprovado`}
            type="svg"
        />
    );

    const gerarTabela = () => {
        return {
            headerRows: 1,
            widths: ['auto', '*', '*', '*'],
            body: [
                [
                    { text: '#', style: 'tableHeader' },
                    { text: 'Nome', style: 'tableHeader' },
                    { text: 'Provincia', style: 'tableHeader' },
                    { text: 'Municipio', style: 'tableHeader' },
                ],
                ...dados.map((empresa, index) => [
                    { text: `${index + 1}`, alignment: 'left', fontSize: 10 },
                    { text: empresa?.nome, alignment: 'left', fontSize: 10 },
                    { text: empresa?.provincia, alignment: 'left', fontSize: 10 },
                    { text: empresa?.municipio, alignment: 'left', fontSize: 10 },
                ]),
            ],
        };
    };

    const docDef = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 60, 40, 40],

        header: {
            columns: [
                { text: new Date().toLocaleDateString('pt-PT'), alignment: 'right', fontSize: 10, margin: [0, 10, 40, 0], color: '#555' },
            ],
        },

        footer: (currentPage, pageCount) => {
            return {
                columns: [
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'left', margin: [40, 0, 0, 0], fontSize: 8, color: '#666' },
                    { text: 'Gerado automaticamente pelo Gestor ARMED', alignment: 'right', margin: [0, 0, 40, 0], fontSize: 8, color: '#666' },
                ],
            };
        },

        content: [
            {
                columns: [
                    {
                        stack: [
                            {
                                svg: qrCodeSVG,
                                width: 55,
                                height: 55,
                                margin: [0, 0, 0, 0],
                            },
                            { text: 'ARMED', alignment: 'left', fontSize: 10, margin: [6, 10, 0, 0], color: '#555' },
                        ],
                        margin: [10, -20, 0, 0]
                    },
                    {
                        stack: [
                            {
                                image: imageBase64,
                                width: 50,
                                height: 50,
                                alignment: "center",
                            },
                            {
                                text: "REPÚBLICA DE ANGOLA",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "MINISTÉRIO DA SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: 'Lista de Empresas',
                                fontSize: 11,
                                style: 'titulo',
                                alignment: 'center',
                                margin: [0, 9, 0, 0]
                            },
                        ],
                        margin: [0, -20, 0, 0]
                    },
                    {
                        text: '',
                        style: '',
                        alignment: 'center',
                    },
                ],
            },
            { text: '\n' },
            {
                table: gerarTabela(),
                layout: {
                    fillColor: function (rowIndex) {
                        return rowIndex === 0 ? '#E0E0E0' : rowIndex % 2 === 0 ? '#F9F9F9' : null;
                    },
                    hLineWidth: function () { return 0.5; },
                    vLineWidth: function () { return 0.5; },
                    hLineColor: function () { return '#aaa'; },
                    vLineColor: function () { return '#aaa'; },
                },
            },
        ],

        styles: {
            titulo: {
                fontSize: 10,
                bold: true,
                color: '#333',
                margin: [0, 0, 0, 0],
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: '#fff',
                fillColor: '#713073',
                alignment: 'center',
                margin: [0, 4, 0, 4],
            },
            tableCell: {
                fontSize: 10,
                color: '#111',
                margin: [0, 3, 0, 3],
            },
        },
    };

    const pdfDoc = pdfMake.createPdf(docDef);
    pdfDoc.open();
};

/** RELATORIO DE REPRESENTANTES **/
const RelatorioRepresentantesPdf = async (dados) => {

    const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) => res.blob());
    const imageBase64 = (await getBase64Image(imageBlob));
    const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCodeSVG
            value={`https://armed.gov.ao/verifica-documento/Reprovado`}
            type="svg"
        />
    );

    const gerarTabela = () => {
        return {
            headerRows: 1,
            widths: ['auto', '*', '*', '*', 'auto', 'auto'],
            body: [
                [
                    { text: '#', style: 'tableHeader' },
                    { text: 'Nome', style: 'tableHeader' },
                    { text: 'Email', style: 'tableHeader' },
                    { text: 'Telefone', style: 'tableHeader' },
                    { text: 'Provincia', style: 'tableHeader' },
                    { text: 'Municipio', style: 'tableHeader' },
                ],
                ...dados.map((representante, index) => [
                    { text: `${index + 1}`, style: 'tableCell' },
                    { text: representante?.dadosPessoais?.nome, style: 'tableCell' },
                    { text: representante?.dadosPessoais?.email, style: 'tableCell' },
                    { text: representante?.dadosPessoais?.tel1, style: 'tableCell' },
                    { text: representante?.dadosPessoais?.provincia, style: 'tableCell' },
                    { text: representante?.dadosPessoais?.municipio, style: 'tableCell' },
                ]),
            ],
        };
    };

    const docDef = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 60, 40, 40],

        header: {
            columns: [
                { text: new Date().toLocaleDateString('pt-PT'), alignment: 'right', fontSize: 10, margin: [0, 10, 40, 0], color: '#555' },
            ],
        },

        footer: (currentPage, pageCount) => {
            return {
                columns: [
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'left', margin: [40, 0, 0, 0], fontSize: 8, color: '#666' },
                    { text: 'Gerado automaticamente pelo Gestor ARMED', alignment: 'right', margin: [0, 0, 40, 0], fontSize: 8, color: '#666' },
                ],
            };
        },

        content: [
            {
                columns: [
                    {
                        stack: [
                            {
                                svg: qrCodeSVG,
                                width: 55,
                                height: 55,
                                margin: [0, 0, 0, 0],
                            },
                            { text: 'ARMED', alignment: 'left', fontSize: 10, margin: [6, 10, 0, 0], color: '#555' },
                        ],
                        margin: [10, -20, 0, 0]
                    },
                    {
                        stack: [
                            {
                                image: imageBase64,
                                width: 50,
                                height: 50,
                                alignment: "center",
                            },
                            {
                                text: "REPÚBLICA DE ANGOLA",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "MINISTÉRIO DA SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: 'Lista de Representantes',
                                fontSize: 11,
                                style: 'titulo',
                                alignment: 'center',
                                margin: [0, 9, 0, 0]
                            },
                        ],
                        margin: [0, -20, 0, 0]
                    },
                    {
                        text: '',
                        style: '',
                        alignment: 'center',
                    },
                ],
            },
            { text: '\n' },
            {
                table: gerarTabela(),
                layout: {
                    fillColor: function (rowIndex) {
                        return rowIndex === 0 ? '#E0E0E0' : rowIndex % 2 === 0 ? '#F9F9F9' : null;
                    },
                    hLineWidth: function () { return 0.5; },
                    vLineWidth: function () { return 0.5; },
                    hLineColor: function () { return '#aaa'; },
                    vLineColor: function () { return '#aaa'; },
                },
            },
        ],

        styles: {
            titulo: {
                fontSize: 10,
                bold: true,
                color: '#333',
                margin: [0, 0, 0, 0],
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: '#fff',
                fillColor: '#713073',
                alignment: 'center',
                margin: [0, 4, 0, 4],
            },
            tableCell: {
                fontSize: 10,
                color: '#111',
                margin: [0, 3, 0, 3],
            },
        },
    };

    const pdfDoc = pdfMake.createPdf(docDef);
    pdfDoc.open();
};

/** RELATORIO DE DIRECTORES TECNICOS **/
const RelatorioDirectoresTecnicosPdf = async (dados) => {
    const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) => res.blob());
    const imageBase64 = (await getBase64Image(imageBlob));
    const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCodeSVG
            value={`https://armed.gov.ao/verifica-documento/Reprovado`}
            type="svg"
        />
    );

    const gerarTabela = () => {
        return {
            headerRows: 1,
            widths: ['auto', '*', 'auto', '*', '*', '*', 'auto', '*'],
            body: [
                [
                    { text: '#', style: 'tableHeader' },
                    { text: 'Nome', style: 'tableHeader' },
                    { text: 'Carteira', style: 'tableHeader' },
                    { text: 'Categoria', style: 'tableHeader' },
                    { text: 'Telefone', style: 'tableHeader' },
                    { text: 'Email', style: 'tableHeader' },
                    { text: 'Provincia', style: 'tableHeader' },
                    { text: 'Estabelecimentos', style: 'tableHeader' }
                ],
                ...dados.map((diretor, index) => [
                    { text: `${index + 1}`, style: 'tableCell' },
                    { text: diretor?.dadosPessoais?.nome, style: 'tableCell' },
                    { text: diretor?.numeroCarteira, style: 'tableCell' },
                    { text: diretor?.categoria?.designacao, style: 'tableCell' },
                    { text: diretor?.dadosPessoais?.tel1, style: 'tableCell' },
                    { text: diretor?.dadosPessoais?.email, style: 'tableCell' },
                    { text: diretor?.dadosPessoais?.provincia, style: 'tableCell' },
                    { text: diretor?.estabelecimentos?.map(e => e.nome).join(', ') || '-', style: 'tableCell' }
                ]),
            ],
        };
    };

    const docDef = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 60, 40, 40],

        header: {
            columns: [
                { text: new Date().toLocaleDateString('pt-PT'), alignment: 'right', fontSize: 10, margin: [0, 10, 40, 0], color: '#555' },
            ],
        },

        footer: (currentPage, pageCount) => {
            return {
                columns: [
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'left', margin: [40, 0, 0, 0], fontSize: 8, color: '#666' },
                    { text: 'Gerado automaticamente pelo Gestor ARMED', alignment: 'right', margin: [0, 0, 40, 0], fontSize: 8, color: '#666' },
                ],
            };
        },

        content: [
            {
                columns: [
                    {
                        stack: [
                            {
                                svg: qrCodeSVG,
                                width: 55,
                                height: 55,
                                margin: [0, 0, 0, 0],
                            },
                            { text: 'ARMED', alignment: 'left', fontSize: 10, margin: [6, 10, 0, 0], color: '#555' },
                        ],
                        margin: [10, -20, 0, 0]
                    },
                    {
                        stack: [
                            {
                                image: imageBase64,
                                width: 50,
                                height: 50,
                                alignment: "center",
                            },
                            {
                                text: "REPÚBLICA DE ANGOLA",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "MINISTÉRIO DA SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: 'Relatorio de Directores Tecnicos',
                                fontSize: 11,
                                style: 'titulo',
                                alignment: 'center',
                                margin: [0, 9, 0, 0]
                            },
                        ],
                        margin: [0, -20, 0, 0]
                    },
                    {
                        text: '',
                        style: '',
                        alignment: 'center',
                    },
                ],
            },
            { text: '\n' },
            {
                table: gerarTabela(),
                layout: {
                    fillColor: function (rowIndex) {
                        return rowIndex === 0 ? '#E0E0E0' : rowIndex % 2 === 0 ? '#F9F9F9' : null;
                    },
                    hLineWidth: function () { return 0.5; },
                    vLineWidth: function () { return 0.5; },
                    hLineColor: function () { return '#aaa'; },
                    vLineColor: function () { return '#aaa'; },
                },
            },
        ],

        styles: {
            titulo: {
                fontSize: 10,
                bold: true,
                color: '#333',
                margin: [0, 0, 0, 0],
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: '#fff',
                fillColor: '#713073',
                alignment: 'center',
                margin: [0, 4, 0, 4],
            },
            tableCell: {
                fontSize: 10,
                color: '#111',
                margin: [0, 3, 0, 3],
            },
        },
    };

    const pdfDoc = pdfMake.createPdf(docDef);
    pdfDoc.open();
};

/** RELATORIO GESTAO DE AGENDA **/
const RelatorioGestaoAgendaPdf = async (dados) => {
    const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) => res.blob());
    const imageBase64 = (await getBase64Image(imageBlob));
    const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCodeSVG
            value={`https://armed.gov.ao/verifica-documento/Reprovado`}
            type="svg"
        />
    );

    const formatarData = (data) => {
        if (!data) return '-';
        const d = new Date(data);
        return d.toLocaleString('pt-PT', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };
    const gerarTabela = () => {
        return {
            headerRows: 1,
            widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', '*'],
            body: [
                [
                    { text: '#', style: 'tableHeader' },
                    { text: 'Tipo de Agenda', style: 'tableHeader' },
                    { text: 'Horario', style: 'tableHeader' },
                    { text: 'Dia', style: 'tableHeader' },
                    { text: 'Mes', style: 'tableHeader' },
                    { text: 'Ano', style: 'tableHeader' },
                    { text: 'Estado', style: 'tableHeader' },
                    { text: 'Data para disponibilizar', style: 'tableHeader' },
                ],
                ...dados.map((agenda, index) => [
                    { text: `${index + 1}`, style: 'tableCell' },
                    { text: agenda?.tipo, style: 'tableCell' },
                    { text: `${agenda?.hora} Horas`, style: 'tableCell' },
                    { text: agenda?.dia, style: 'tableCell' },
                    { text: agenda?.mes, style: 'tableCell' },
                    { text: agenda?.ano, style: 'tableCell' },
                    { text: agenda?.status, style: 'tableCell' },
                    { text: formatarData(agenda?.dataDisponivel), style: 'tableCell' },
                ]),
            ],
        };
    };

    const docDef = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 60, 40, 40],

        header: {
            columns: [
                { text: new Date().toLocaleDateString('pt-PT'), alignment: 'right', fontSize: 10, margin: [0, 10, 40, 0], color: '#555' },
            ],
        },

        footer: (currentPage, pageCount) => {
            return {
                columns: [
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'left', margin: [40, 0, 0, 0], fontSize: 8, color: '#666' },
                    { text: 'Gerado automaticamente pelo Gestor ARMED', alignment: 'right', margin: [0, 0, 40, 0], fontSize: 8, color: '#666' },
                ],
            };
        },

        content: [
            {
                columns: [
                    {
                        stack: [
                            {
                                svg: qrCodeSVG,
                                width: 55,
                                height: 55,
                                margin: [0, 0, 0, 0],
                            },
                            { text: 'ARMED', alignment: 'left', fontSize: 10, margin: [6, 10, 0, 0], color: '#555' },
                        ],
                        margin: [10, -20, 0, 0]
                    },
                    {
                        stack: [
                            {
                                image: imageBase64,
                                width: 50,
                                height: 50,
                                alignment: "center",
                            },
                            {
                                text: "REPÚBLICA DE ANGOLA",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "MINISTÉRIO DA SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: 'Relatorio de Gestão de Agendas',
                                fontSize: 11,
                                style: 'titulo',
                                alignment: 'center',
                                margin: [0, 9, 0, 0]
                            },
                        ],
                        margin: [0, -20, 0, 0]
                    },
                    {
                        text: '',
                        style: '',
                        alignment: 'center',
                    },
                ],
            },
            { text: '\n' },
            {
                table: gerarTabela(),
                layout: {
                    fillColor: function (rowIndex) {
                        return rowIndex === 0 ? '#E0E0E0' : rowIndex % 2 === 0 ? '#F9F9F9' : null;
                    },
                    hLineWidth: function () { return 0.5; },
                    vLineWidth: function () { return 0.5; },
                    hLineColor: function () { return '#aaa'; },
                    vLineColor: function () { return '#aaa'; },
                },
            },
        ],

        styles: {
            titulo: {
                fontSize: 10,
                bold: true,
                color: '#333',
                margin: [0, 0, 0, 0],
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: '#fff',
                fillColor: '#713073',
                alignment: 'center',
                margin: [0, 4, 0, 4],
            },
            tableCell: {
                fontSize: 10,
                color: '#111',
                margin: [0, 3, 0, 3],
            },
        },
    };

    const pdfDoc = pdfMake.createPdf(docDef);
    pdfDoc.open();
};

/** RELATORIO ADIMINISTRADORES DO SISTEMA **/
const RelatorioAdministadoresPdf = async (dados) => {
    const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) => res.blob());
    const imageBase64 = (await getBase64Image(imageBlob));
    const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCodeSVG
            value={`https://armed.gov.ao/verifica-documento/Reprovado`}
            type="svg"
        />
    );

    const gerarTabela = () => {
        return {
            headerRows: 1,
            widths: ['auto', '*', '7%', '10%', '10%', '10%', '10%', '10%', '9%', '10%', 'auto', 'auto'],
            body: [
                [
                    { text: '#', style: 'tableHeader' },
                    { text: 'Nome', style: 'tableHeader' },
                    { text: 'Departamento', style: 'tableHeader' },
                    { text: 'Seccao', style: 'tableHeader' },
                    { text: 'Agente', style: 'tableHeader' },
                    { text: 'Funcao', style: 'tableHeader' },
                    { text: 'BI', style: 'tableHeader' },
                    { text: 'Email', style: 'tableHeader' },
                    { text: 'Telefone 1', style: 'tableHeader' },
                    { text: 'Bairro', style: 'tableHeader' },
                    { text: 'Distrito / Municipio', style: 'tableHeader' },
                    { text: 'Provincia', style: 'tableHeader' },
                ],
                ...dados.map((representante, index) => [
                    { text: `${index + 1}`, style: 'tableCell' },
                    { text: representante?.dadosPessoais?.nome, style: 'tableCell' },
                    { text: representante?.departamento, style: 'tableCell' },
                    { text: representante?.seccao, style: 'tableCell' },
                    { text: representante?.numeroAgente, style: 'tableCell' },
                    { text: representante?.funcao, style: 'tableCell' },
                    { text: representante?.dadosPessoais?.numeroBI, style: 'tableCell' },
                    { text: representante?.dadosPessoais?.email, style: 'tableCell' },
                    { text: representante?.dadosPessoais?.tel1, style: 'tableCell' },
                    { text: representante?.dadosPessoais?.bairro, style: 'tableCell' },
                    { text: representante?.dadosPessoais?.municipio, style: 'tableCell' },
                    { text: representante?.dadosPessoais?.provincia, style: 'tableCell' },
                ]),
            ],
        };
    };

    const docDef = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [40, 60, 40, 40],

        header: {
            columns: [
                { text: new Date().toLocaleDateString('pt-PT'), alignment: 'right', fontSize: 10, margin: [0, 10, 40, 0], color: '#555' },
            ],
        },

        footer: (currentPage, pageCount) => {
            return {
                columns: [
                    { text: `Página ${currentPage} de ${pageCount}`, alignment: 'left', margin: [40, 0, 0, 0], fontSize: 8, color: '#666' },
                    { text: 'Gerado automaticamente pelo Gestor ARMED', alignment: 'right', margin: [0, 0, 40, 0], fontSize: 8, color: '#666' },
                ],
            };
        },

        content: [
            {
                columns: [
                    {
                        stack: [
                            {
                                svg: qrCodeSVG,
                                width: 55,
                                height: 55,
                                margin: [0, 0, 0, 0],
                            },
                            { text: 'ARMED', alignment: 'left', fontSize: 10, margin: [6, 10, 0, 0], color: '#555' },
                        ],
                        margin: [10, -20, 0, 0]
                    },
                    {
                        stack: [
                            {
                                image: imageBase64,
                                width: 50,
                                height: 50,
                                alignment: "center",
                            },
                            {
                                text: "REPÚBLICA DE ANGOLA",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "MINISTÉRIO DA SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: "AGÊNCIA REGULADORA DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE",
                                style: 'titulo',
                                alignment: 'center',
                            },
                            {
                                text: 'Lista de Usuarios do sistema',
                                fontSize: 11,
                                style: 'titulo',
                                alignment: 'center',
                                margin: [0, 9, 0, 0]
                            },
                        ],
                        margin: [0, -20, 0, 0]
                    },
                    {
                        text: '',
                        style: '',
                        alignment: 'center',
                    },
                ],
            },
            { text: '\n' },
            {
                table: gerarTabela(),
                layout: {
                    fillColor: function (rowIndex) {
                        return rowIndex === 0 ? '#E0E0E0' : rowIndex % 2 === 0 ? '#F9F9F9' : null;
                    },
                    hLineWidth: function () { return 0.5; },
                    vLineWidth: function () { return 0.5; },
                    hLineColor: function () { return '#aaa'; },
                    vLineColor: function () { return '#aaa'; },
                },
            },
        ],

        styles: {
            titulo: {
                fontSize: 10,
                bold: true,
                color: '#333',
                margin: [0, 0, 0, 0],
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: '#fff',
                fillColor: '#713073',
                alignment: 'center',
                margin: [0, 4, 0, 4],
            },
            tableCell: {
                fontSize: 10,
                color: '#111',
                margin: [0, 3, 0, 3],
            },
        },
    };

    const pdfDoc = pdfMake.createPdf(docDef);
    pdfDoc.open();
};



export {
    RelatorioAdministadoresPdf,
    RelatorioRepresentantesPdf,
    SolicitacaoLicenciamentoPdf,
    SolicitacaoLicenciamentoReprovadosPdf,
    EstabelecimentosLicenciadospdf,
    RelatorioEmpresasPdf,
    RelatorioDirectoresTecnicosPdf,
    RelatorioGestaoAgendaPdf,
};
